import React from 'react';

import Dropdown from '../Dropdown';

export default class Multiselect extends React.Component {
  render() {
    return <Dropdown multi {...this.props} />
  }
}
